import * as React from 'react';
import ChatViewState from '../store/schema/ChatViewState';
import { setPendingMessage } from '../actions/ucmaActions';
import { observer } from 'mobx-react';
import { sendMessage } from '../actions/ucmaActions';

export interface InputBoxProps {
    chat: ChatViewState;
}

@observer
export default class InputBox extends React.Component<InputBoxProps, {}> {
    private input = React.createRef<HTMLInputElement>();

    render() {
        const { chat } = this.props;
        return (
            <div>
                <input
                    type="text"
                    value={chat.pendingMessage}
                    ref={this.input}
                    onChange={this.onChange}
                    onKeyDown={this.onKeyDown}
                />
            </div>
        );
    }

    private onChange = () => {
        setPendingMessage(this.props.chat, this.input.current.value);
    };

    private onKeyDown = (e: React.KeyboardEvent<EventTarget>) => {
        if (e.key == 'Enter') {
            e.preventDefault();
            sendMessage(this.props.chat);
        }
    };
}
